module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Toc_Link7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("INTERLAKEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO-2"
  }, [_vm._v("The trip across the Pacific was, Noguchi said, “fabulous … with two Fourth-of-Julys at the international-date-line. My first view of America was the pine-spired coastline of the North West and the passage past Victoria to Seattle. There was a man from the YMCA on the pier who took me into town and put me on a train.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-1",
      "id": "cha-1"
    }
  }, [_vm._v("1")])]), _vm._v(" The man made sure that Isamu had a nametag inscribed with his destination attached to his shirt. He gave Isamu a stick of Juicy Fruit chewing gum: “What a wonderful country to have such a wonderful thing like that. So I felt very happy about America…”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-2",
      "id": "cha-2"
    }
  }, [_vm._v("2")])]), _vm._v(" On the three-day trip the train was packed with soldiers (World War I would not be over for another four months). The soldiers were amused by Isamu and gave him food and drink. In Chicago Isamu changed trains and two hours later changed again to a local intercity line. When he finally arrived at Rolling Prairie, the journey had taken three weeks. “How I had gotten there from Japan is due to the luck that attends little boys. This also accounts for my quickly finding friends and being introduced to America in the ideal setting of the Indiana countryside, during the best possible time of year, in a summer camp. My mother had judged well in selecting this school where boys ‘learned to know by doing.’”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-3",
      "id": "cha-3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("At Rolling Prairie station Isamu was met by someone from Interlaken. The two-mile walk to the school passed through cornfields blanketing low, undulant hills. Isamu was amazed at the openness of the land and the dry heat. “I got the feeling of America superimposed on the old Japanese. It was a view of nature which was quite different. Here nature is appreciated for its vastness, its sweep…”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-4",
      "id": "cha-4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("On July 25 C. A. Lewis, the director of the summer school, wrote to Dr. Rumely about Isamu’s arrival: “I have a little Jap in camp—half Japanese, half English. He’s a peach. He was muchly interested in wood-work, wanted to go to the wood-shop. I sent him, with flying colors. He came back to me almost in tears. ‘I wanted to make something that I’ve planned for a long time, and Mr. Hedrain [the rigid Swedish shop teacher] set me to planing a block of wood, just to plane it.’” Mr. Lewis arranged a space with a bench and storage shelves where Isamu could work. He was amazed by what Isamu produced with the Japanese tools he had brought with him: “He can carve a Jap cod a heap better than Hedrain could in a year of Sundays, and he can make a spoon more quickly and artistically than Hedrain can in his—So I have him at it, and the boys are already weaving a path to his door.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-5",
      "id": "cha-5"
    }
  }, [_vm._v("5")])]), _vm._v(" Among the pieces that Isamu carved that summer was a frieze of seaweed, fish, and shells on a headboard.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("In a 1946 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Art News")]), _vm._v(" article on Noguchi, the critic and editor Thomas B. Hess told a similar, but partly apocryphal story. Isamu, he said, “appeared at the door of Dr. Edward Allen Rumely, Director of Interlaken, with a prospectus in his hand, demanding tools. Later that day, Rumely remembers, one of the boys came to him saying: ‘Sir, there’s the strangest kid outside, he pulls the chisel and pushes the saw.’ Rumely went out and saw there, squatting under a tree, his newest pupil carving on a wooden plate a fish and flowers of Japan.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-6",
      "id": "cha-6"
    }
  }, [_vm._v("6")])]), _vm._v(" The problem with this version of events is that Rumely was not at Interlaken when Isamu arrived. Thanks to drought, crop failure, and overextended finances, his tractor company was sold in 1915, and he and his family moved to New York City. In July 1918, the month in which Isamu arrived at Interlaken, Rumely was arrested and convicted of perjury. He was perceived to be pro-German because of certain views expressed in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Evening Mail")]), _vm._v(", the New York newspaper for which he served as publisher and editor in chief. The case dragged on until 1924. Noguchi recalled that Rumely was “a remarkable man, who out of idealism made this school … He is a great influence on me, although for almost a year, I was out of touch.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-7",
      "id": "cha-7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Noguchi was happy living in a tent at summer camp; perhaps it reminded him of the tent he and his mother had lived in when he was a toddler in California. The campers swam in Silver Lake before breakfast. At 6:00 a.m. they ate eggs and milk from the school’s own dairy. After breakfast there were various chores to be performed and then another swim at noon. In the afternoon they studied and engaged in sports. Lights out was at nine. Isamu’s roommate, an older Filipino boy named Agapoan, taught Isamu how to ride a horse."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-8",
      "id": "cha-8"
    }
  }, [_vm._v("8")])]), _vm._v(" Noguchi recalled that Agapoan had been sent to an exposition in San Francisco to be put on display as “a sample of a wild man … He was a wild boy from the Igarat, you know. Lived in trees.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-9",
      "id": "cha-9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Because of the war, communication with Japan was difficult. Although Isamu missed his mother, he had spent so much time alone during the last decade that he had learned not to need the people he loved. Asked if he thought about his mother while in Indiana, Noguchi said: “I thought of her always, with thinking how what a tough time she had. Financially and so forth … I’m sure my father never helped her.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-10",
      "id": "cha-10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("In a September 14, 1918, letter from Leonie to Rumely’s daughter, who had given her news of Isamu, Leonie asked to be kept informed, for Isamu’s letters were too brief, and those from the school’s superintendent, too businesslike."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-11",
      "id": "cha-11"
    }
  }, [_vm._v("11")])]), _vm._v(" By the time Leonie wrote this letter, Isamu’s life had been transformed. The school had closed due to the anti-German backlash and probably also because of Rumely’s arrest. In late August the campus was taken over by army recruits who were to establish an army motor pool. “That fall the school did not open,” Noguchi recalled. “Instead, the place was turned into a motor truck training camp, and while all the other children went home, I was left alone to watch soldiers, trucks, mess halls and barracks take over the grounds. I became a sort of mascot.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-12",
      "id": "cha-12"
    }
  }, [_vm._v("12")])]), _vm._v(" “Even the Igarat boy had a place to go to. I didn’t … But then … the soldiers were coming in so it was very exciting … I liked it even better. I was alone then. I was boss.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-13",
      "id": "cha-13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Noguchi camped out with two caretakers in a deserted faculty building. “I had the use of a horse upon which I rode out like a cowboy at four in the morning to fetch the mail and the victuals, getting back in time to make breakfast.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-14",
      "id": "cha-14"
    }
  }, [_vm._v("14")])]), _vm._v(" In early October the school’s superintendent sent Leonie a cable: “School Closed Send Money Advice.” Leonie wrote back: “In the emergency I wish Isamu to go to public High School in La Porte and will be obliged if you will consult with the secretary of the Y.M.C.A. about finding a home for him. If there is a Boy Scouts organization the scout master might be interested in helping to place him.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-15",
      "id": "cha-15"
    }
  }, [_vm._v("15")])]), _vm._v(" In mid-October she received three letters from Isamu and one from the school asking for tuition—Leonie’s checks seemed to have gone astray in the mail. On October 14 Leonie responded: “My first thought on hearing of the closing of the school, was that I must take the first opportunity to go to America myself, and I am now trying to make an engagement over there. If you hear of an opening I should be glad to know of it.” There was, she said, the possibility of secretarial work for a member of the Bryn Mawr faculty, but the salary of one hundred dollars did not seem sufficient for the journey to America and living expenses. She thought the cost of living might be cheaper on the West Coast."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-16",
      "id": "cha-16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("That autumn many of the soldiers came down with the influenza, a worldwide epidemic that killed some twenty million people in 1918. Noguchi recalled that some of the soldiers died and that he, too, was stricken with a high fever. While recovering in bed he read Arthurian legends in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Morte d’Arthur")]), _vm._v(" and perused the Bible."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-17",
      "id": "cha-17"
    }
  }, [_vm._v("17")])]), _vm._v(" After the Armistice on November 11, the soldiers left and the caretakers tried to keep the place going. “Winter came, and I had no place to go, since my mother could not afford to send me elsewhere. Nobody seemed to be in charge of me.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-18",
      "id": "cha-18"
    }
  }, [_vm._v("18")])]), _vm._v(" As usual, he managed. “I felt like Daniel Boone … I would get in a canoe and paddle across the lake there and look for food and this and that. And there was a dog I liked.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-19",
      "id": "cha-19"
    }
  }, [_vm._v("19")])]), _vm._v(" The period of being alone at Interlaken lasted only about a month, but Noguchi said that it had felt much longer. In December the wife of the school’s treasurer, Mrs. C. A. Lewis, took Isamu home with her to Rolling Prairie, where she enrolled him in public school and found him work in a garage. The school placed Isamu in a class with children younger than himself, which must have been humiliating. “I had my birth certificate … I had no school diploma, no nothing. So they put me backwards.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-20",
      "id": "cha-20"
    }
  }, [_vm._v("20")])]), _vm._v(" Even worse, unlike the liberal atmosphere of Interlaken, the Rolling Prairie public school children looked askance at this foreigner. He was small for his age and there was a Japanese cast to his features. Once again he felt like a misfit. “Yeah, in Rolling Prairie they ganged up on me. They were gonna beat me up. And I remembered enough jiu-jitsu, so I threw one over my head. And then they became very quiet, very quiet. Very respectful … you have to prove yourself.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes48#chapter6-21",
      "id": "cha-21"
    }
  }, [_vm._v("21")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec84e26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 90
// module chunks = 0